import { Search } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

interface ModeToggleBarProps {
  searchEnabled: boolean;
  aiEnabled: boolean;
  onSearchToggle: (enabled: boolean) => void;
  onAIToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

const baseStyles = `
  relative h-10 w-10 rounded-xl flex items-center justify-center
  transition-all duration-200 ease-out border-2
`;

const onStyles = 'border-primary bg-background shadow-sm';
const offStyles = 'border-transparent bg-muted/50 opacity-50 hover:opacity-75';

export function ModeToggleBar({
  searchEnabled,
  aiEnabled,
  onSearchToggle,
  onAIToggle,
  disabled = false,
}: ModeToggleBarProps) {
  const { toast } = useToast();

  const handleSearchToggle = () => {
    if (searchEnabled && !aiEnabled) return;
    const next = !searchEnabled;
    onSearchToggle(next);
    toast({ title: next ? 'Arche Search enabled' : 'Arche Search disabled' });
  };

  const handleAIToggle = () => {
    if (aiEnabled && !searchEnabled) return;
    const next = !aiEnabled;
    onAIToggle(next);
    toast({ title: next ? 'Fias AI enabled' : 'Fias AI disabled' });
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleSearchToggle}
        disabled={disabled}
        title={searchEnabled ? 'Disable search' : 'Enable search'}
        className={`${baseStyles} ${searchEnabled ? onStyles : offStyles} ${
          disabled ? 'cursor-not-allowed !opacity-40' : 'cursor-pointer'
        }`}
      >
        <Search className={`h-6 w-6 ${searchEnabled ? 'text-primary' : 'text-muted-foreground'}`} />
      </button>

      <button
        onClick={handleAIToggle}
        disabled={disabled}
        title={aiEnabled ? 'Disable Fias AI' : 'Enable Fias AI'}
        className={`${baseStyles} ${aiEnabled ? onStyles : offStyles} ${
          disabled ? 'cursor-not-allowed !opacity-40' : 'cursor-pointer'
        }`}
      >
        <img src="/Heptagen_Logo_1.png" alt="Fias AI" className="h-7 w-7 object-contain" />
      </button>
    </div>
  );
}
